/*
 * Deskon - keeps the cart drawer's additions correct across state changes.
 *
 * TWO BUGS LIVE HERE, BOTH ABOUT LIFECYCLE RATHER THAN RENDERING.
 *
 * 1. THE ORPHANED OBSERVER. deskon-cart-drawer.js attached its MutationObserver to the
 *    <cart-drawer-component> node it found at load. That node is REPLACED when the cart section is
 *    re-rendered, which orphans the observer: it watches an element no longer in the document,
 *    apply() is never called again, and the theme's original cart shows through. The fix is to
 *    watch something that is never replaced - document.body outlives every section render.
 *
 * 2. APPLY() ONLY EVER ADDED. Each piece is guarded by "does my element already exist?", which
 *    makes it idempotent in ONE DIRECTION ONLY. Nothing removed what had stopped being true. Open
 *    the page with an empty cart, the empty state is injected; add an item, and mountEmpty() sees
 *    its element already present and returns early WITHOUT removing it - so "Discover the
 *    collection" stays on top of the item list. Adding a guard is not enough: the state has to be
 *    torn down as well as built.
 *
 * SO THIS PRUNES BEFORE IT MOUNTS, on two different grounds:
 *
 *    BY STATE - the empty block belongs to an empty cart, the timer and the savings pill to a
 *    filled one. Whichever set contradicts the current item count is removed outright.
 *
 *    BY VALUE - the savings figure is baked into its markup at mount time, so it goes stale
 *    silently when the cart changes. Rather than diffing text, the raw JSON of the data island is
 *    compared against the last pass: if it changed at all, the pill is dropped and rebuilt from the
 *    new numbers.
 *
 * THE UPSELL CARD USED TO BE IN BOTH LISTS AND IS THE REASON THE VALUE RULE EXISTS AT ALL: its
 * Add/Added label was decided when the card was cloned and could not follow the cart. The card is
 * gone - replaced by the multibuy bar, which snippets/cart-summary.liquid renders on the server
 * inside <cart-items-component>, so the theme itself re-renders it and nothing here has to. THAT
 * IS THE PATTERN TO PREFER: a value that comes from the cart belongs in Liquid, not in a clone
 * this file has to keep chasing.
 *
 * THE TIMER IS DELIBERATELY EXEMPT FROM THE VALUE RULE. Its markup does not depend on the cart's
 * contents, and rebuilding it would restart its interval on every single cart change - a visible
 * stutter in the countdown. It is only removed when the cart empties.
 *
 * PRUNING IS CHEAP AND THE OBSERVER IS DEBOUNCED to one animation frame, because a body-level
 * subtree observer fires constantly on a busy page. Everything downstream is idempotent, so a
 * spurious pass costs a handful of getElementById lookups.
 *
 * ------------------------------------------------------------------------------------------------
 * "A SPURIOUS PASS IS CHEAP" WAS WRONG, AND IT COST THE WHOLE SITE HALF ITS FRAMES.
 *
 * A pass is not cheap - apply() measured about 15.7ms on the live product page, against a frame
 * budget of 16.7ms - and the passes were not spurious in the sense of rare. They were CONTINUOUS,
 * because the observer was watching the very DOM its own callback writes to:
 *
 *     apply() writes the savings pill's text
 *       -> assigning textContent replaces the text node even when the string has not changed
 *         -> childList mutation on document.body's subtree
 *           -> this observer fires, schedule() queues a frame
 *             -> apply() writes the savings pill's text ...
 *
 * Measured: 57 passes a second, for the life of the page, on EVERY page of the site - the drawer
 * lives in the header. The browser sat at roughly 30fps doing nothing at all, which is why every
 * animation on this theme looked like it was stepping. The product page's accordions were simply
 * where it was finally noticed; there was never anything wrong with them.
 *
 * TWO THINGS FIX IT AND BOTH ARE DELIBERATE. deskon-cart-drawer.js now compares before it writes,
 * so the DOM stays quiet. And run() below DISCONNECTS this observer while it works, so a future
 * unconditional write anywhere in apply() cannot start the loop again.
 *
 * DISCONNECTING LOSES NOTHING. JavaScript is single-threaded: while apply() is running, no other
 * code on the page can mutate the DOM, so there is no external change to miss. The only records
 * dropped are this file's own, which is exactly the point. takeRecords() empties the queue that
 * built up before the disconnect for the same reason.
 * ------------------------------------------------------------------------------------------------
 */

(function () {
  'use strict';

  var EMPTY_ONLY = ['deskon-cart-empty'];
  var FILLED_ONLY = ['deskon-cart-expiry', 'deskon-cart-savings'];
  var VALUE_BOUND = ['deskon-cart-savings'];

  var lastSignature = null;

  function drop(id) {
    var node = document.getElementById(id);
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  function prune() {
    var tag = document.getElementById('deskon-cart-data');
    if (!tag) return;

    var raw = tag.textContent;
    var info;
    try {
      info = JSON.parse(raw);
    } catch (e) {
      return;
    }

    var changed = raw !== lastSignature;
    lastSignature = raw;

    var empty = !info.itemCount;

    (empty ? FILLED_ONLY : EMPTY_ONLY).forEach(drop);

    /* The cart's numbers moved: anything that hardcoded them at mount time is now wrong. */
    if (changed && !empty) VALUE_BOUND.forEach(drop);
  }

  /* Held so run() can switch it off around its own work - see the note at the top. */
  var observer = null;
  var WATCHING = { childList: true, subtree: true };

  function resume() {
    if (!observer) return;
    /* Drop what this pass queued, then start listening again. */
    observer.takeRecords();
    observer.observe(document.body, WATCHING);
  }

  function run() {
    var api = window.deskonCart;
    if (!api || typeof api.apply !== 'function') return;

    if (observer) observer.disconnect();
    try {
      prune();
      api.apply();
    } finally {
      resume();
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }

  function start() {
    if (!document.body) {
      setTimeout(start, 50);
      return;
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, WATCHING);
    }

    /* The drawer may only be populated when it is opened. */
    document.addEventListener('click', function () { setTimeout(run, 60); }, true);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);

    var passes = 0;
    var poll = setInterval(function () {
      run();
      if (++passes > 20) clearInterval(poll);
    }, 500);

    run();
  }

  start();
})();
